import type {QueryClient} from '@tanstack/react-query';
import type {Dispatch} from 'react';

import {setServerClientAccessToken} from '../clients/server';
import {setStrapiClientAccessToken} from '../clients/strapi';
import {clearSentryUser} from '../monitoring/set-sentry-user';
import {type StoreAction} from '../store/storeReducer';
import {clearStoredAuthTokens} from './authStorage';
import {currentUserQueryRootKey} from './currentUserQuery';
import {LS_SELECTED_DOMAIN} from '~/store/useStoreContext';

export function performAppLogout(
  queryClient: QueryClient,
  dispatch: Dispatch<StoreAction>,
): void {
  queryClient.removeQueries({queryKey: currentUserQueryRootKey});
  clearSentryUser();
  clearStoredAuthTokens();
  setServerClientAccessToken(undefined);
  setStrapiClientAccessToken(undefined);
  localStorage.removeItem(LS_SELECTED_DOMAIN);
  dispatch({type: 'SET_APP_LOGOUT'});
}
